import { Route } from 'react-router-dom';
import { lazyPage } from './lazyPage';

const DocumentsDashboard = lazyPage(() => import('../pages/staff/documents/Dashboard'), 'Dashboard');
const Students = lazyPage(() => import('../pages/staff/Students'), 'Students');
const MasterList = lazyPage(() => import('../pages/staff/MasterList'), 'MasterList');
const StudentProfile = lazyPage(() => import('../pages/staff/StudentProfile'), 'StudentProfile');
const BulkGenerate = lazyPage(() => import('../pages/staff/BulkGenerate'), 'BulkGenerate');
const ProfileReports = lazyPage(() => import('../pages/staff/ProfileReports'), 'ProfileReports');
const ProfileFields = lazyPage(() => import('../pages/staff/settings/ProfileFields'), 'ProfileFields');
const StudentForm = lazyPage(() => import('../pages/staff/StudentForm'), 'StudentForm');
const StudentDetail = lazyPage(() => import('../pages/staff/StudentDetail'), 'StudentDetail');
const DocumentStatus = lazyPage(() => import('../pages/staff/DocumentStatus'), 'DocumentStatus');
const ReadyDocuments = lazyPage(() => import('../pages/staff/ReadyDocuments'), 'ReadyDocuments');
const SignedDocuments = lazyPage(() => import('../pages/staff/SignedDocuments'), 'SignedDocuments');
const DocumentTracking = lazyPage(() => import('../pages/staff/DocumentTracking'), 'DocumentTracking');
const DocumentForm = lazyPage(() => import('../pages/staff/DocumentForm'), 'DocumentForm');

/**
 * Documents module and the shared student pages. All sit under the
 * fullAccess guard (staff who are not LD Assistants).
 */
export const documentsRoutes = (
  <>
    <Route path="/staff/documents" element={<DocumentsDashboard />} />
    <Route path="/staff/documents/student/:id" element={<StudentForm />} />
    {/* The Master List: every student with a Learning Diversity profile,
        sorted and filtered server-side. */}
    <Route path="/staff/master-list" element={<MasterList />} />
    {/* The Learning Diversity profile. Distinct from the older
        /staff/students/:id detail page, which serves the document module
        and reads Synergetic endpoints that do not exist (#164). */}
    <Route path="/staff/students/:id/profile" element={<StudentProfile />} />
    {/* Bulk document generation across a cohort. */}
    <Route path="/staff/documents/generate" element={<BulkGenerate />} />
    {/* Reporting over the profile: goal categories, adjustment
        effectiveness, and the modified-curriculum-goal export. */}
    <Route path="/staff/reports" element={<ProfileReports />} />
    {/* Custom profile fields. Writes are admin-only at the database, so a
        non-admin reaching this page can look but not change. */}
    <Route path="/staff/settings/profile-fields" element={<ProfileFields />} />
    <Route path="/staff/students" element={<Students />} />
    <Route path="/staff/students/:id" element={<StudentDetail />} />
    <Route path="/staff/documents/list" element={<DocumentStatus />} />
    <Route path="/staff/documents/ready" element={<ReadyDocuments />} />
    <Route path="/staff/documents/signed" element={<SignedDocuments />} />
    <Route path="/staff/documents/tracking" element={<DocumentTracking />} />
    <Route path="/staff/documents/document/new" element={<DocumentForm />} />
    <Route path="/staff/documents/document/new/:studentId" element={<DocumentForm />} />
    <Route path="/staff/documents/document/:id" element={<DocumentForm />} />
  </>
);
